export const categories = [
  {
    slug: "Officeandbusiness",
    title: "Office and Business Tools",
    whoCanJoin:"Beginners",
    build:"Build real-world full stack applications.",
    duration: "Multiple Programs",
    icon: "officeandbusiness"
},
{
    slug: "kidzcoding",
    title: "Kids Coding Level 1 - 3 ",
    whoCanJoin:"6-16 years",
    build:"To strengthen logic & problem-solving and gradually introduce kids to: Advanced Scratch logic",
    duration: "Multiple Programs",
    icon: "kidz"
},
{
    slug: "CPC",
    title: "Core Programming",
    whoCanJoin:"Beginners",
    build:"Build real-world full stack applications.",
    duration: "Multiple Programs",
    icon: "coreprogram"
},
{
  slug: "fullstack",
  title: "Full Stack Development",
  whoCanJoin:"Beginners",
  build:"Build real-world full stack applications.",
  duration: "Multiple Programs",
  icon: "laptop"
},
{
  slug: "datascience",
  title: "Data Science & AI",
  whoCanJoin:"Beginners",
  build:"Build real-world full stack applications.",
  duration: "Multiple Programs",
  icon: "Python"
},

{
    slug: "design",
    title: "Designing",
    whoCanJoin:"Beginners",
    build:"Build real-world full stack applications.",
    duration: "Multiple Programs",
    icon: "design"
},

{
    slug: "MobileDevlopment",
    title: "Mobile App Development",
    whoCanJoin:"Beginners",
    build:"Build real-world full stack applications.",
    duration: "Multiple Programs",
    icon: "mobile"
},
];